import React, {useMemo, useState} from "react";
import styles from './EditCadetModal.module.scss';
import TextInput from "../../Components/TextInput/TextInput";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import {PROD_API_URL} from "../../constants/constants";
import toast from "react-hot-toast";
import {errorToast, successToast} from "../../helpers/toastCSS";
import TabSelector from "../../Components/TabSelector/TabSelector";
import moment from "moment";
import {DataGrid} from "@mui/x-data-grid";
import {hasValue} from "../../helpers/helperFunctions";

const TAB_WALLET_ADMINISTRATION = 'TAB_WALLET_ADMINISTRATION';
const TAB_CADET_INFORMATION = 'TAB_CADET_INFORMATION';
const TAB_SALES_INFORMATION = 'TAB_SALES_INFORMATION';
const TAB_VAULT_INFORMATION = 'TAB_VAULT_INFORMATION';

const tabOptions = [
    { key: TAB_CADET_INFORMATION, label: 'Cadet Information'},
    { key: TAB_WALLET_ADMINISTRATION, label: 'Wallet Administration'},
    { key: TAB_SALES_INFORMATION, label: 'Sales Information'},
    { key: TAB_VAULT_INFORMATION, label: 'Vault Information'}
];

const idoColumns = [
    { field: 'name', headerName: 'Name', flex: 2 },
    { field: 'contributedStarsAmount', headerName: 'Contributed STARS', flex: 1 },
    { field: 'contributedUSDCAmount', headerName: 'Contributed USDC', flex: 1 },
    { field: 'date', headerName: 'Date', width: 200 },
];

const raffleColumns = [
    { field: 'name', headerName: 'Name', flex: 2 },
    { field: 'purchasedTickets', headerName: 'Tickets Purchased', flex: 1 },
    { field: 'ticketPrice', headerName: 'Ticket Price', flex: 1 },
    { field: 'date', headerName: 'Date', width: 200 },
];

export const KYC_STATUS_FETCHING = 0;
export const KYC_STATUS_APPROVED = 1;
export const KYC_STATUS_NOT_APPROVED = 2;
export const KYC_STATUS_PENDING = 3;
export const KYC_STATUS_FAILED = 4;

function EditCadetModal(props) {
    const {
        cadetData,
        setCadetData
    } = props;

    const [tab, setTab] = useState(TAB_CADET_INFORMATION);

    const [ethereumWalletInput, setEthereumWalletInput] = useState(cadetData.ethereumWallet);
    const [polygonWalletInput, setPolygonWalletInput] = useState(cadetData.polygonWallet);
    const [arbitrumWalletInput, setArbitrumWalletInput] = useState(cadetData.arbitrumWallet);
    const [supraWalletInput, setSupraWalletInput] = useState(cadetData.supraWallet);
    const [suiWalletInput, setSUIWalletInput] = useState(cadetData.suiWallet);
    const [avalancheWalletInput, setAvalancheWalletInput] = useState(cadetData.avalancheWallet);
    const [dymensionWalletInput, setDymensionWalletInput] = useState(cadetData.dymensionWallet);

    const closeModal = () => {
      setCadetData(null);
    }


    const saveCadetData = async () => {
      const formattedCadetData = cadetData.id ? delete cadetData.id : cadetData
      const resp = await fetch(PROD_API_URL + '/cadetInfo', {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "accept": "*",
          'Cookie': 'sails.sid=s%3Avh-tedPOHnJh8E0RhjeC820oxrGU6DwJ.5AwSIniluWQcyz%2B6f7UJ8fDteBEX08UIFEXBltW6tfc'
        },
        body: JSON.stringify({
          cadetId: cadetData.cadetId,
          solanaWallet: cadetData.solanaWallet,
          ethereumWallet: ethereumWalletInput,
          polygonWallet: polygonWalletInput,
          arbitrumWallet: arbitrumWalletInput,
          supraWallet: supraWalletInput,
          suiWallet: suiWalletInput,
          avalancheWallet: avalancheWalletInput,
          dymensionWallet: dymensionWalletInput,
          ...formattedCadetData
        }),
      });

      if (resp.ok) {
        toast('Cadet Wallet Updated!', successToast)
      } else {
        toast('Saving Cadet Wallet failed', errorToast)
      }
      closeModal();
    }
    console.log(cadetData)
    const idoParticipationRows = useMemo(() => {
        if (!cadetData?.participation?.idoParticipations) return [];
        return cadetData?.participation?.idoParticipations.map(participation => {
            return {
                id: participation.idoName,
                name: participation.idoName,
                contributedStarsAmount: hasValue(participation?.contributedStarsAmount) ? Number(participation?.contributedStarsAmount).toFixed(2) : "",
                contributedUSDCAmount: participation.isNodeSale ? participation.nodePrice * participation.purchasedNodeAmount : participation.contributedUSDCAmount,
                date: moment.unix(participation?.transactions[0].timestamp / 1000).format('YYYY-MM-DD , h:mm A'),
            }
        });
    }, [cadetData]);

    const raffleParticipationRows = useMemo(() => {
        return cadetData?.participation?.raffleParticipations.map(participation => {
            return {
                id: participation.raffleId,
                name: participation.raffleName,
                purchasedTickets: participation.purchasedTickets,
                ticketPrice: participation.ticketPrice,
                date:  participation?.transactions ? moment.unix(participation?.transactions[0].timestamp / 1000).format('YYYY-MM-DD , h:mm A') : '',
            }
        });
    }, [cadetData]);

    return (
        <div className={styles.editCadetOverlay}>
            <div className={styles.editCadetContainer}>
                <h4>SOL WALLET: {cadetData?.solanaWallet}</h4>
                <TabSelector
                    setValue={setTab}
                    value={tab}
                    options={tabOptions}/>
                {tab === TAB_CADET_INFORMATION && <div className={styles.cadetInformationContainer}>
                    {cadetData.profileImage && <img className={styles.profileImage} src={cadetData.profileImage}/>}
                    <span>Username: <b>{cadetData.username}</b></span>
                    <span>Discord: <b>{cadetData.discordUsername}</b></span>
                    <span>Telegram: <b>{cadetData.telegramUsername}</b></span>
                    <span>X/Twitter: <b>{cadetData.twitterUsername}</b></span>
                    <span>Email: <b>{cadetData.email}</b></span>
                    <span>Privacy Policy Consent: <b>{cadetData.consentPrivacyPolicy ? 'Yes' : 'No'}</b></span>
                    <br/>
                    <span>Has Vault Account: <b>{cadetData.hasVaultAccount ? 'Yes' : 'No'}</b></span>
                    <span>Has IDO Account: <b>{cadetData.hasIdoAccount ? 'Yes' : 'No'}</b></span>
                    <span>Has Node IDO Account: <b>{cadetData.hasNodeIdoAccount ? 'Yes' : 'No'}</b></span>
                    <br/>
                    <span>Completed KYC Verification: <b>{cadetData.kycApproved ? 'Yes' : 'No'}</b></span>
                    <span>Country: <b>{cadetData.country}</b></span>
                    {cadetData?.completedUtc && <span>KYC Verification Date: <b>{moment(cadetData.completedUtc).format('YYYY-MM-DD , h:mm A')}</b></span>}
                </div>}
                {tab === TAB_WALLET_ADMINISTRATION && <div className={styles.walletAdministrationContainer}>
                    <TextInput value={ethereumWalletInput} setValue={setEthereumWalletInput} label="ETHEREUM WALLET"/>
                    <TextInput value={polygonWalletInput} setValue={setPolygonWalletInput} label="POLYGON WALLET"/>
                    <TextInput value={arbitrumWalletInput} setValue={setArbitrumWalletInput} label="ARBITRUM WALLET"/>
                    <TextInput value={supraWalletInput} setValue={setSupraWalletInput} label="SUPRA WALLET"/>
                    <TextInput value={suiWalletInput} setValue={setSUIWalletInput} label="SUI WALLET"/>
                    <TextInput value={avalancheWalletInput} setValue={setAvalancheWalletInput}
                               label="AVALANCHE WALLET"/>
                    <TextInput value={dymensionWalletInput} setValue={setDymensionWalletInput}
                               label="DYMENSION WALLET"/>
                </div>}
                {tab === TAB_SALES_INFORMATION && <div className={styles.cadetInformationContainer}>
                    {cadetData?.totalRaised && <span>USDC Contributed: <b>{cadetData?.totalRaised.toFixed(2)}</b></span>}
                    {cadetData?.totalStarsContributed && <span>STARS Contributed: <b>{cadetData?.totalStarsContributed.toFixed(2)}</b></span>}
                    <h4>IDO Participations</h4>
                    {cadetData?.participation?.idoParticipations.length > 0 && <div className={styles.cadetTableContainer}>
                        <DataGrid
                            rows={idoParticipationRows}
                            columns={idoColumns}
                        />
                    </div>}
                        <br/>
                        <h4>Raffle Participations</h4>
                    {cadetData?.participation?.raffleParticipations.length > 0 && <div className={styles.cadetTableContainer}>
                        <DataGrid
                            rows={raffleParticipationRows}
                            columns={raffleColumns}
                        />
                    </div>}

                </div>}
                <span>Updated At: <b>{moment.unix(cadetData.updatedAt / 1000).format('YYYY-MM-DD , h:mm A')}</b></span>
                <span>Created At: <b>{moment.unix(cadetData.createdAt / 1000).format('YYYY-MM-DD , h:mm A')}</b></span>
                <div className={styles.editCadetFooter}>
                    <Button text="CANCEL" onClick={closeModal} buttonType={BUTTON_TYPE_SECONDARY}/>
                    <Button text="SUBMIT CHANGES" onClick={saveCadetData} buttonType={BUTTON_TYPE_SECONDARY}/>
                </div>
            </div>
        </div>
    );
}

export default EditCadetModal;
